(() => {
  const root = document.documentElement;
  if (root.getAttribute('data-ap-product-entry') !== 'pending') return;
  const content = document.querySelector('main .ap-product-layout');
  const product = content?.closest('aplovio-product');
  const loader = product?.querySelector('[data-product-entry-loading]');
  const mobile = matchMedia('(max-width:989px)');
  const reducedMotion = matchMedia('(prefers-reduced-motion:reduce)');
  const lifecycle = new AbortController();
  const options = {signal: lifecycle.signal};
  let timeout;

  function finish() {
    root.removeAttribute('data-ap-product-entry');
    if (loader) loader.hidden = true;
    clearTimeout(timeout);
    lifecycle.abort();
  }

  if (document.body.hasAttribute('data-ap-vertical-gallery') || !content || !product || !mobile.matches || reducedMotion.matches || document.hidden) { finish(); return; }
  if (loader) loader.hidden = false;
  timeout = setTimeout(finish, 3000);

  for (const type of ['animationend', 'animationcancel']) {
    content.addEventListener(type, event => {
      if (event.target === content && event.animationName === 'ap-product-entry') finish();
    }, options);
  }
  for (const type of ['pointerdown', 'touchstart', 'wheel', 'keydown']) {
    document.addEventListener(type, finish, {...options, capture: true, passive: true});
  }
  window.addEventListener('pagehide', finish, options);
  mobile.addEventListener('change', finish, options);
  reducedMotion.addEventListener('change', finish, options);
  document.addEventListener('visibilitychange', () => { if (document.hidden) finish(); }, options);

  const ready = new Promise(resolve => {
    if (product.productReady) { resolve(true); return; }
    product.addEventListener('aplovio:product-ready', () => resolve(true), {...options, once: true});
    lifecycle.signal.addEventListener('abort', () => resolve(false), {once: true});
  });
  const images = [...content.querySelectorAll('img')].filter(image => {
    const bounds = image.getBoundingClientRect();
    return bounds.width > 0 && bounds.height > 0 && bounds.bottom > 0 && bounds.top < innerHeight && bounds.right > 0 && bounds.left < innerWidth;
  });
  const decoded = images.map(async image => {
    // A pending reveal must not stop a visible lazy image from requesting its source.
    image.loading = 'eager';
    try { await image.decode(); return image.naturalWidth > 0; }
    catch { return false; } // A failed image reveals the ordinary page, without a late animation.
  });

  Promise.all([ready, document.fonts.ready.then(() => true, () => false), ...decoded]).then(results => {
    if (lifecycle.signal.aborted) return;
    if (root.getAttribute('data-ap-product-entry') !== 'pending' || results.includes(false)) { finish(); return; }
    clearTimeout(timeout);
    if (loader) loader.hidden = true;
    root.setAttribute('data-ap-product-entry', 'running');
  });
})();
